import {
  Box,
  Button,
  TextField,
  Typography
} from "@mui/material";
import "./OtpFieldStyle.css";
import React, { useRef, useState } from "react";
import { useGlobalContext } from "../../../context/GlobalContext";

const OtpFieldComp = () => {

  const [otp, setOtp] = useState(new Array(4).fill(""));
  const [errorIndex, setErrorIndex] = useState([]); // 🎯 Track error positions
  const inputRefs = useRef([]);
  const [error, setError] = useState(null);
  const Pin = process.env.REACT_APP_SELECT_PIN;

  const { setOrderScreen } = useGlobalContext();

  function handlePaste(e) {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();

    if (!/^\d+$/.test(pastedData)) return;

    const newOtp = pastedData.split("").slice(0, otp.length);
    setOtp((prevOtp) => prevOtp.map((_, i) => newOtp[i] || ""));
    setErrorIndex([]); // 🎯 Clear error when pasting

    if (newOtp?.length === otp?.length) {
      inputRefs?.current[otp?.length - 1]?.blur();
    } else {
      inputRefs?.current[Math.min(newOtp?.length, otp?.length - 1)]?.focus();
    }
  }

  function handleKeyDown(e, index) {
    if (e.key === "Backspace") {
      if (otp[index]) {
        setOtp((prevOtp) => {
          const newOtp = [...prevOtp];
          newOtp[index] = "";
          return newOtp;
        });
      } else if (index > 0) {
        inputRefs.current[index - 1].focus();
        setOtp((prevOtp) => {
          const newOtp = [...prevOtp];
          newOtp[index - 1] = "";
          return newOtp;
        });
      }
      setErrorIndex([]); // 🎯 Remove error when typing
    }
  }

  function handleChange(e, index) {
    let value = e?.target?.value;
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    setErrorIndex([]); // 🎯 Remove error when typing

    if (value && index < otp?.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  }

  function handleSubmitClick() {
    const emptyIndices = otp
      .map((digit, i) => (digit === "" ? i : null))
      .filter((i) => i !== null);

    if (emptyIndices?.length > 0) {
      // 🎯 Show error on empty fields
      setErrorIndex(emptyIndices);
      // 🎯 Focus on first empty input
      inputRefs.current[emptyIndices[0]]?.focus();
      setError("Please fill all Fields");
      return;
    }

    if (otp?.join("") !== Pin) {
      setErrorIndex([0, 1, 2, 3]);
      setError("Please enter correct PIN");
      return;
    }

    setErrorIndex([]);
    setOtp(new Array(otp?.length)?.fill(""));
    inputRefs?.current[0]?.focus();
    setOrderScreen(true);
  }

  const handlePress = (e) => {
    if (e.key === "Enter") {
      handleSubmitClick();
    }
  };

  const errorText = {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: ".55vw",
    lineHeight: "100%",
    color: "#F23D3D",
    marginTop: ".75vw",
  };

  return (
    <>
      <Box
        className="otp-modal"
        sx={{ height: error ? "16vw" : "15vw" }}
      >
        <Box
          borderRadius=".5vw"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "90%",
            flexGrow: 1,
          }}
        >
          <Box>
            <Typography className="field-header">Order Lock</Typography>

            <Box>
              <Typography className="otp-label">Enter the PIN</Typography>

              <Box
                onKeyDown={handlePress}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: ".8vw",
                }}
              >
                {otp?.map((data, index) => (
                  <TextField
                    key={index}
                    id={`pin-${index}`}
                    value={data}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    inputRef={(el) => (inputRefs.current[index] = el)}
                    onPaste={(e) => handlePaste(e)}
                    variant="outlined"
                    autoComplete="off"
                    inputProps={{
                      maxLength: 1,
                      style: {
                        textAlign: "center",
                        fontSize: "1.25vw",
                        height: "4.5vw",
                        width: "4.5vw",
                        backgroundColor: "#fff",
                        borderRadius: ".6vw",
                        color: "black",
                        boxShadow: "inset 0 .3vw 1vw 0 rgba(0, 0, 0, .4)",
                        padding: 0,
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: ".6vw",
                        padding: 0,
                        "& fieldset": {
                          borderColor: errorIndex?.includes(index)
                            ? "#F23D3D"
                            : "#ccc",
                          borderWidth: errorIndex?.includes(index)
                            ? ".15vw"
                            : ".1vw",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errorIndex?.includes(index)
                            ? "#F23D3D"
                            : "#50c878",
                          borderWidth: ".2vw",
                        },
                      },
                      width: "4.5vw",
                      height: "4.5vw",
                      minWidth: "4.5vw",
                      minHeight: "4.5vw",
                      maxWidth: "4.5vw",
                      maxHeight: "4.5vw",
                    }}
                  />
                ))}
              </Box>
              {errorIndex?.length > 0 && (
                <Typography sx={{ ...errorText }}>{error}</Typography>
              )}
            </Box>
          </Box>
        </Box>

        <Button
          variant="contained"
          className="otpBtn"
          fullWidth
          onClick={() => handleSubmitClick()}
          sx={{
            padding: "1.2vw",
            lineHeight: "0px",
          }}
        >
          SUBMIT
        </Button>
      </Box>
    </>
  );
};

export default OtpFieldComp;
